import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Reason → CTA action. Texts live in dashboard:emptyState.* (de/en/hr).
const REASON_CTA = {
  no_active_listings: null,
  all_filtered_out: "reset",
  preferences_too_narrow: "reset",
  image_health_only_dead: "adjust",
  strict_coverage_only_analyzed: null,
  country_filter_zero_match: "reset",
  market_engine_filters_too_strict: null,
  mongo_timeout: "retry",
  server_error: "retry",
};

const KNOWN_REASONS = new Set(Object.keys(REASON_CTA));

export default function EmptyState({ reason, country, onReset, onToggleUnchecked, onRetry, extraCta }) {
  const { t } = useTranslation("dashboard");
  const key = KNOWN_REASONS.has(reason) ? reason : "default";
  const ctaAction = REASON_CTA[reason] || null;

  const title = t(`emptyState.${key}.title`);
  const body =
    key === "country_filter_zero_match" && country
      ? t("emptyState.country_filter_zero_match.body_with_country", { country })
      : t(`emptyState.${key}.body`);

  return (
    <div
      data-testid="empty-state"
      className="border border-zinc-800 bg-zinc-950/60 rounded-2xl p-10 text-center"
    >
      <h3 className="text-xl text-zinc-100 mb-2">{title}</h3>
      <p className="text-sm text-zinc-400 mb-6 max-w-prose mx-auto">{body}</p>
      <div className="flex items-center justify-center gap-3 flex-wrap">
        {(ctaAction === "reset" || ctaAction === "adjust") && onReset && (
          <button
            data-testid="empty-state-reset"
            onClick={onReset}
            className="px-4 py-2 rounded-lg bg-amber-500 text-zinc-950 text-sm font-medium hover:bg-amber-400"
          >
            {ctaAction === "adjust" ? t("emptyState.ctaAdjust") : t("emptyState.ctaReset")}
          </button>
        )}
        {ctaAction === "retry" && onRetry && (
          <button
            data-testid="empty-state-retry"
            onClick={onRetry}
            className="px-4 py-2 rounded-lg bg-amber-500 text-zinc-950 text-sm font-medium hover:bg-amber-400"
          >
            {t("emptyState.ctaRetry")}
          </button>
        )}
        {extraCta}
        <Link
          to="/preferences"
          className="text-sm text-zinc-400 hover:text-zinc-200 underline-offset-4 hover:underline"
        >
          {t("emptyState.editPrefs")} →
        </Link>
      </div>
    </div>
  );
}
